export default "__VITE_ASSET__BjzYHZml__"